export class AppealStatusSearchModel {
    constructor(data = {}) {
        this.email = data.email ?? '';
        this.lastName = data.lastName ?? '';
        this.appealId = data.appealId ?? '';

        // response fields
        this.appealStatus = data.appealStatus ?? null;
        this.appealOutcome = data.appealOutcome ?? null;
        this.iroAt = data.iroAt ?? null;

        this.error = data.error ?? '';
    }
}
